module.exports = __webpack_public_path__ + "media/images/ai-search-32bccf34d5de28819468c9acf7f0255d.png";